var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.rotas_login)?_c('TheMenu'):_vm._e(),(_vm.rotas_login && _vm.usuario_logado)?_c('TheMenuLogado'):_vm._e(),_c('main',{attrs:{"id":"main"}},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.rotas_login)?_c('TheFooter',{attrs:{"id":"contato"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }